import React, {Component} from 'react';
import '../CSS/Footer.css';

export default class Footer extends Component {
    render() {
        return <footer>This is a footer</footer>
    }


}